import React from 'react'
import './card.css'

export default function Card({ details }) {
    return (
        <div className='card'>
            <div className='impressions'><i className="fa-solid fa-eye"></i> {details.impressions}</div>
            <div className='event-image' style={{ backgroundImage: `url('${details.photo}')` }}></div>
            <div className='event-details'>
                <div className='event-name'>Name- <strong>{details.name}</strong></div>
                <div className='event-org'>Organization- <strong>{details.organization}</strong></div>
                <div className='event-deadline'>Last Date- <strong>{details.applicationDeadline[0].split('T')[0].split('-')[2]}/{details.applicationDeadline[0].split('T')[0].split('-')[1]}/{details.applicationDeadline[0].split('T')[0].split('-')[0]}</strong></div>
            </div>
            <div className='card-details-btn-container'>
                <a className='card-details-btn' href={`/${details.type.split('Details')[0]}/${details._id}`}>Details</a>
            </div>
        </div>
    )
}
